import { IError, IModalError } from "../interfaces/modal-error";

export const errorModal: IError = {
    // Token scaduto
    AUTH001: {
        header: "ATTENZIONE!",
        body: "Sessione scaduta.",
        footer: "Per accedere nuovamente ai servizi effettuare nuovamente la procedura di autenticazione."
    },
    //ATTIVITA CLIENTE - CONSEGNA AL CLIENTE - VERIFICA PIN/PACCO
    CNS1001: {
        header: "Lunghezza PIN errata",
        body: "Il PIN inserito non consente di effettuare la consegna del pacco perchè è composto da un numero di caratteri < 6 oppure > 36.",
        footer: "Controlla la lunghezza del PIN e prova ad inserirlo nuovamente."
    },
    CNS1002: {
        header: "PIN non trovato",
        body: "Il PIN inserito non consente di effettuare la consegna perchè non corrisponde a nessun pacco.",
        footer: "Controlla il PIN e prova ad inserirlo nuovamente."
    },
    CNS1003: {
        header: "Pacco già lavorato",
        body: "Il PIN inserito non consente di effettuare la consegna perché il pacco è già stato lavorato.",
        footer: "Comunica al cliente che il PIN è già stato utilizzato."
    },
    CNS1004: {
        header: "Pacco non trovato",
        body: "Si è verificato un errore nel recapito del pacco che risulta disponibile presso un altro PuntoPoste.",
        footer: "Comunica al cliente che il ritiro del pacco dovrà essere effettuato presso un altro PuntoPoste."
    },
    CNS1005: {
        header: "PIN non utilizzabile",
        body: "Il PIN inserito non può essere utilizzato per la consegna perchè è associato ad un pacco che ha compiuto i termini di giacenza previsti.",
        footer: "Verifica se il pacco è già stato affidato al corriere per la restituzione al mittente."
    },
    CNS1006: {
        header: "Pacco errato.",
        body: "In seguito alla scansione del codice, non viene trovata nessuna corrispondenza con un pacco.",
        footer: "Verifica il codice e prova ad effettuare ancora la scansione. In caso di nuovo errore, non sarà più possibile proseguire con l'attività."
    },
    CNS1007: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    CNS2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    CNS3001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    CNS4001: {
        header: "CODICE PACCO ERRATO",
        body: "Riprova ad inserirlo.",
        footer: ""
    },
    CNS4002: {
        header: "PACCO NON TROVATO",
        body: "Codice non riconosciuto",
        footer: ""
    },
    CNS4003: {
        header: "PACCO NON CONSEGNABILE",
        body: "Controlla nella sezione “Consegna al corriere” e, se presente nella bolla, premi “Annulla”.",
        footer: ""
    },
    CNS4004: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività  a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    CNS4005: {
        header: "Codice non accettabile",
        body: "Il pacco risulta già consegnato.",
        footer: ""
    },
    //[CUSTOMER DROPOFF] verifica accettazione
    ACC1001: {
        header: "Accettazione oltre orario limite",
        body: "L'attività di accettazione è stata svolta in un momento successivo all'orario limite previsto.",
        footer: "Proseguire regolarmente l'attività di accettazione del pacco."
    },
    ACC1002: {
        header: "Accettazione non consentita.",
        body: "Il portale non consente di accettare il pacco.",
        footer: ""
    },
    ACC1003: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[CUSTOMER DROPOFF] paperless
    ACC3001: {
        header: "Accettazione non consentita",
        body: "Il portale non consente di accettare il pacco.",
        footer: ""
    },
    ACC3002: {
        header: "Codice non corretto",
        body: "Prova nuovamente ad effettuare la scansione del codice.",
        footer: ""
    },
    ACC3003: {
        header: "Formato non riconosciuto",
        body: "Formato codice non riconosciuto, scansiona il codice corretto.",
        footer: ""
    },
    ACC3004: {
        header: "Stampa non consentita",
        body: "Dati non disponibili, stampa non consentita.",
        footer: ""
    },
    ACC3005: {
        header: "Accettazione non consentita",
        body: "Impossibile determinare il prodotto, accettazione non consentita",
        footer: ""
    },
    ACC3006: {
        header: "Stampa non consentita",
        body: "Dati non disponibili, stampa non consentita.",
        footer: ""
    },
    ACC3007: {
        header: "Codice non valido",
        body: "Impossibile procedere alla stampa, codice non valido.",
        footer: ""
    },
    ACC3008: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[COURIER PICKUP]
    PKU1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    PKU2002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    PKU2004: {
        header: "Bolla già acquisita",
        body: "Non è possibile creare la bolla che è già stata creata e successivamente acquisita dal corriere tramite il palmare.",
        footer: "Attendi la conclusione dell'attività prima di procedere con la creazione di una nuova bolla."
    },
    PKU4001: {
        header: "Bolla non creata",
        body: "Non è possibile creare la bolla perche è già stata creata su un altro dispositivo in uso al PuntoPoste.",
        footer: "Rilascia la bolla per crearne una nuova o utilizza quella precedentemente creata sull'altro dispositivo."
    },
    PKU4002: {
        header: "Bolla già acquisita",
        body: "Non è possibile creare la bolla che è già stata creata e successivamente acquisita dal corriere tramite il palmare.",
        footer: "Attendi la conclusione dell'attività prima di procedere con la creazione di una nuova bolla."
    },
    PKU4003: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    PKU5001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    PKU6001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    PKU8001: {
        header: "Bolla non disponibile",
        body: "La bolla è stata annullata o prelevata dal corriere tramite palmare.",
        footer: ""
    },
    PKU8002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[COURIER DROPOFF]
    DRF1001: {
        header: "Codice errato o già lavorato",
        body: "Non è possibile procedere con l'attività.",
        footer: "Verifica il codice e prova ad effettuare ancora la scansione. In caso di nuovo errore, non sarà più possibile proseguire con l'attività."
    },
    DRF1002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    DRF1003: {
        header: "Codice non accettabile",
        body: "Non è possibile procedere con l'attività.",
        footer: "Scansiona il codice da \"Accettazione dal cliente\" oppure invita il corriere a ricontrollare il recapito."
    },
    DRF1004: {
        header: "Codice non accettabile",
        body: "Il pacco è già presente all'interno del magazzino.",
        footer: ""
    },
    DRF1005: {
        header: "Codice non accettabile",
        body: "Il pacco risulta già consegnato.",
        footer: ""
    },
    DRF2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //ATTIVITA CLIENTE - VENDITA - VERIFICA PIN/PACCO
    VEN1001: {
        header: "Codice inesistente",
        body: "Il codice inserito non è corretto.",
        footer: "Accertati di aver inserito correttamente il codice del pacco."
    },
    VEN1002: {
        header: "Codice già venduto",
        body: "Il codice è già stato venduto",
        footer: "Utilizza un altro pacco"
    },
    VEN1003: {
        header: "Codice non vendibile",
        body: "Utilizza un altro pacco",
        footer: ""
    },
    VEN1004: {
        header: "Vendita non consentita",
        body: "Il portale non consente di vendere il pacco.",
        footer: ""
    },
    VEN1005: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    VEN2001: {
        header: "Codice non vendibile",
        body: "Utilizza un altro pacco",
        footer: ""
    },
    VEN2002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[RECUPERO PASSWORD]
    LCS1001: {
        header: "Password non recuperata",
        body: "L'attività di recupero della password non può essere eseguita perchè le informazioni inserite non sono corrette.",
        footer: "Verifica i dati e prova ad inserirli nuovamente."
    },
    LCS1002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    LCS1004: {
        header: "Operazione non consentita",
        body: "Non è possibile recuperare la password perché l'utenza è temporaneamente sospesa.",
        footer: "Attendi il termine del periodo di sospensione oppure contatta l'assistenza."
    },
    LCS1005: {
        header: "Operazione non consentita",
        body: "L'operazione richiesta non è disponibile per l'utenza nello stato attuale.",
        footer: ""
    },
    //[RECUPERO USERNAME]
    LCS2001: {
        header: "Username non recuperato",
        body: "L'attività di recupero dello username non può essere eseguita perché le informazioni inserite non sono corrette.",
        footer: "Verifica i dati e prova ad inserirli nuovamente."
    },
    LCS2002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    LCS2004: {
        header: "Operazione non consentita",
        body: "Non è possibile recuperare lo username perché l'utenza è temporaneamente sospesa.",
        footer: "Attendi il termine del periodo di sospensione oppure contatta l'assistenza."
    },
    LCS2005: {
        header: "Operazione non consentita",
        body: "L'operazione richiesta non è disponibile per l'utenza nello stato attuale.",
        footer: ""
    },
    //[MAGAZZINO]
    MGZ1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[VERIFICA_PACCHI]
    VRF1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    VRF2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    VRF3001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    VRF4001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    VRF5001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[INF]
    INF1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    INF2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    INF3001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    INF4001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    INF5001: {
        header: "Nessun risultato",
        body: "Non è stato trovato nessun dato presente per il periodo di tempo selezionato.",
        footer: "Inserisci un intervallo di date differente per effettuare una nuova ricerca."
    },
    INF5002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    INF5003: {
        header: "Nessun risultato",
        body: "Non è stato trovato nessun dato presente per il filtro impostato.",
        footer: "Inserisci un filtro differente per effettuare una nuova ricerca."
    },
    //[CAMBIO PASSWORD]
    PWD1001: {
        header: 'Password non valida',
        body: 'La password inserita non corrisponde all\'utente.',
        footer: 'Verifica la correttezza dei dati inseriti e riprovare.'
    },
    PWD1002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    PWD1003: {
        header: "Password non valida",
        body: "La password è uguale a una delle ultime 5 utilizzate.",
        footer: "Inserisci una password diversa."
    },
    PWD1004: {
        header: "Operazione non consentita",
        body: "Operazione non consentita: l'utenza non risulta abilitata in base al suo stato attuale.",
        footer: ""
    },
    //[NOTIFICHE]
    COM1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    COM2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    COM3001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC4001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC4002: {
        header: "Servizio non ammesso",
        body: "Il servizio di reso boxless non è abilitato.",
        footer: ""
    },
    ACC4003: {
        header: "Formato non riconosciuto",
        body: "Formato codice non riconosciuto, scansiona il codice corretto.",
        footer: ""
    },
    ACC4004: {
        header: "Accettazione non consentita",
        body: "Dati non disponibili, accettazione non consentita.",
        footer: ""
    },
    ACC4005: {
        header: "Codice non corretto",
        body: "Prova nuovamente ad effettuare la scansione del codice.",
        footer: ""
    },
    ACC4006: {
        header: "Accettazione non consentita",
        body: "Impossibile determinare il prodotto, accettazione non consentita",
        footer: ""
    },
    ACC5001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC6001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC7001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    LDV1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    LDV1002: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    LDV2001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    LDV2002: {
        header: "Codice inesistente",
        body: "Il codice inserito non è corretto.",
        footer: "Accertati di averlo inserito correttamente."
    },
    LDV2003: {
        header: "Codice già scansionato",
        body: "Oggetto già inserito nella scatola numero ",
        footer: "Accertati di averlo inserito correttamente."
    },
    PKU7001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    RTZ1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //[ERRORE GENERICO 4XX 5XX]
    GENERIC: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    RES1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    RES1002: {
        header: "Nessun servizio disponibile",
        body: "Non è stato trovato nessun servizio associato.",
        footer: "Accertati di avere un servizio di reso associato."
    },
    RES1003: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    RES1004: {
        header: "Nessun prodotto disponibile",
        body: "Non è stato trovato nessun prodotto per il catalogo selezionato.",
        footer: "Accertati che il catalogo selezionato abbia dei prodotti di reso associati."
    },
    RES1005: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    RES1006: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    APS1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    APS1002: {
        header: "Nessun risultato",
        body: "Non è stato trovato nessun dato presente per il periodo di tempo selezionato.",
        footer: "Inserisci un intervallo di date differente per effettuare una nuova ricerca."
    },
    DHL1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC3009: {
        header: "",
        body: "Il PuntoPoste non può accettare il pacco perchè non ha il servizio [ACCETTAZIONE PACCHI CON STAMPA LDV] attualmente nello stato IN CORSO!",
        footer: ""
    },
    APS1004: {
      header: "Servizio non disponibile",
      body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
      footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    //Second Hand
    ACC6002: {
      header: "Servizio non ammesso",
      body: "Il servizio di accettazione boxless second hand non è abilitato.",
      footer: ""
    },
    ACC6003: {
      header: "Servizio non ammesso",
      body: "L'accettazione del cliente non prevede il servizio boxless second hand.",
      footer: ""
    },
    APP1003: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    EVT1001: {
        header: "Servizio non disponibile",
        body: "Non è possibile proseguire l'attività a causa di un malfunzionamento temporaneo del portale.",
        footer: "Effettua la disconnessione dal portale e riprova dopo qualche minuto."
    },
    ACC1004: {
       header: "Lettera di vettura non valida",
       body: "Per maggiori dettagli invitare il cliente a contattare il merchant",
       footer: ""
    },
    ACC3010: {
       header: "Lettera di vettura non valida",
       body: "Per maggiori dettagli invitare il cliente a contattare il merchant",
       footer: ""
    },
	SRV001: {
	   header: "Operazione non consentita",
	   body: "PuntoPoste non abilitato al servizio",
	   footer: ""
	},
    LOGIN0001: {
        header: "Accesso non consentito",
        body: "E'possibile accedere solo tramite il dispositivo dedicato al servizio Punto Poste",
        footer: ""
    }
}

export const setModalError = (code: string): IModalError => {
  return errorModal[code] ?? errorModal['GENERIC'];
}
